import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { Button } from "react-bootstrap";
import getFilterSelectorTranslation from "src/functions/getFilterSelectorTranslation";
import { filtersSelector } from "src/styles/sFilterSelector.module.scss";

type Props = {
  enabled: boolean;
  onClick: () => void;
  title: any;
  values?: any;
};

export default function FiltersSelector({
  enabled,
  onClick,
  title,
  values,
}: Props) {
  const { locale: lang } = useRouter();

  return (
    <Button
      variant={enabled ? `outline-primary` : `link`}
      size="sm"
      className={composeClassNames([filtersSelector])}
      onClick={onClick}
    >
      {getFilterSelectorTranslation(title, lang)}
      {typeof values !== undefined &&
        typeof values !== "object" &&
        values !== null &&
        values && <span className={`count`}>({values})</span>}
    </Button>
  );
}
